export const paths = {
  main: {
    dashboard: '/dashboard',
    dashboardV2: '/dashboard/v2',
    forgotPassword: '/forgot-password',
    login: '/',
  },
  dashboard: {
    dashboard: '/dashboard',
    editProfile: '/dashboard/profile/edit',
    event: (id = '') => `/dashboard/v2/evento/${id}`,
    myEvents: '/dashboard/mis-eventos',
    newEvent: '/dashboard/evento/nuevo',
    pastEvents: '/dashboard/eventos-pasados',
    profile: '/dashboard/profile',
    transactions: `/dashboard/transactions`,
  },
  event: {
    members: (teamId = '', tournamentId = '') =>
      `/dashboard/v2/miembros/${teamId}/torneo/${tournamentId}`,
    journeysMain: (eventId = '', groupId = '') =>
      `/dashboard/v2/evento/${eventId}/jornadas/${groupId}`,
    journeys: (eventId = '', groupId = '', matchDayId = '', matchId = '') =>
      `/dashboard/v2/evento/${eventId}/jornadas/${groupId}/encuentro/${matchDayId}/details/${matchId}`,
    lineupRequest: (teamId = '', tournamentId = '') =>
      `/dashboard/v2/miembros/${teamId}/torneo/${tournamentId}/solicitudes`,
  },
};
